import { useEffect } from "react";

/**
 * Scrolls a target element into view when content is ready (e.g. form below hero on mobile).
 * Pair with scroll-mt-* on the target so fixed header clears.
 */
export function useScrollIntoViewWhenReady(ref, enabled, options = {}) {
  const { mobileOnly = true, delayMs = 180, behavior = "smooth" } = options;

  useEffect(() => {
    if (!enabled) return;
    if (mobileOnly && typeof window !== "undefined") {
      if (!window.matchMedia("(max-width: 767px)").matches) return;
    }
    const t = window.setTimeout(() => {
      ref.current?.scrollIntoView({ behavior, block: "start" });
    }, delayMs);
    return () => window.clearTimeout(t);
  }, [enabled, mobileOnly, delayMs, behavior, ref]);
}
